import script from "./ReferenceList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceList.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceList.vue?vue&type=style&index=0&id=10bac9ef&lang=sass"

const __exports__ = script;

export default __exports__